import { Directive, Self, OnInit, ViewContainerRef, ComponentRef, ComponentFactoryResolver, Inject, Input, Optional, OnDestroy } from '@angular/core';
import { NgControl, FormControl, AbstractControl } from '@angular/forms';

import { ControlErrorComponent } from './control-error.component';
import { FORM_ERRORS } from './errors';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { ForceUpdateService } from '../core/services/force-update.service';
import { merge } from 'rxjs';



@Directive({
  // selector: '[appErrorForm]'
  selector: '[formControl], [formControlName]' //la direttiva si appoggia ad attributi già presenti nelle form.
})
export class ErrorFormDirective implements OnDestroy {

  ref: ComponentRef<ControlErrorComponent>; //Recuper il riferimento al componente che mostra gli errori
  container: ViewContainerRef; //inizializzo il view ref
  //submit$: Observable<Event>;
  @Input() customErrors = {};

  @Input() parent: string;
  @Input() disableErrors = false
  constructor(
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    @Optional() controlErrorContainer: ControlErrorContainerDirective, //direttiva per gestione errore custom
    @Inject(FORM_ERRORS) private errors, //recupero errori da classe esterna
    private controlDir: NgControl,
    private forceUpdateService: ForceUpdateService
  ) {
    this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
  }


  ngOnInit() {
    // this.setAndControlErrors(this.control);
    if (!this.disableErrors) merge(
      this.forceUpdateService.getSubject(),
      this.control.valueChanges
    )
      .subscribe((filter) => {

        if (filter && filter.array && Array.isArray(filter.array)) {
          let found: any
          if (!this.parent || (this.parent.split('.').length == 1 && this.parent.split('.')[0] == filter.parent)) {
            found = filter.array.find(a => a === this.getName);
          } else if (this.parent && this.parent.split('.')[0] == filter.parent && this.parent.split('.')[1] && this.parent.split('.')[1] == this.getParentName) {
            found = filter.array.find(a => a === this.getName);
          }
          if (found)
            this.setAndControlErrors(this.control);

        } else {
          this.setAndControlErrors(this.control);

        }
      });
  }

  setAndControlErrors(control: AbstractControl) {
    const controlErrors = control.errors; //verifico presenza errori
    if (controlErrors) {
      const firstKey = Object.keys(controlErrors)[0];
      const getError = this.errors[firstKey]; //errrors è un oggetto con chiave uguale al tipo di errore, e valore metodo che dai dati dell'errore costruisce il msg
      const text = this.customErrors[firstKey] || getError(controlErrors[firstKey]);
      this.setError(text);
    } else if (this.ref) {
      this.setError(null);
    }
  }

  get control() {
    return this.controlDir.control;
  }
  get getName() {
    return this.controlDir.name;
  }

  get getParentName() {
    return this.controlDir['_parent'].name;
  }

  setError(text: string) {
    if (!this.ref) {
      const factory = this.resolver.resolveComponentFactory(ControlErrorComponent);
      this.ref = this.vcr.createComponent(factory);
    }

    this.ref.instance.text = text;
    this.ref.instance.disableErrors = this.disableErrors;
  }

  ngOnDestroy() {

  }


}
